import { useEffect, useState } from 'react';

import { Dialog, DialogContent } from '@playbooks/ui/components/dialog';

import { WorkspaceMcpFlowForm } from 'components/agent/workspace-mcp-flow-form';
import { WorkspaceMcpFlowSelect } from 'components/agent/workspace-mcp-flow-select';

const WorkspaceMcpFlow = ({
	open,
	setOpen,
	initialView = 'select',
	selected = [],
	canManageServers,
	onSave,
	onCreate,
}) => {
	const [view, setView] = useState(initialView);
	const [model, setModel] = useState(null);
	const [values, setValues] = useState(selected);

	useEffect(() => {
		if (!open) return;
		setModel(null);
		setValues(selected);
		setView(initialView);
	}, [initialView, open, selected]);

	const onClose = () => setOpen(false);
	const onCreated = async mcp => {
		const next = [mcp, ...values.filter(item => item.id !== mcp.id)];
		setValues(next);
		setModel(null);
		setView('select');
	};

	return (
		<Dialog open={open} onOpenChange={nextOpen => !nextOpen && onClose()}>
			<DialogContent variant='form' className='sm:max-w-2xl'>
				{view === 'select' ? (
					<WorkspaceMcpFlowSelect
						selected={values}
						setSelected={setValues}
						canManageServers={canManageServers}
						onClose={onClose}
						onAdd={() => canManageServers && setView('form')}
						onEdit={mcp => {
							if (!canManageServers) return;
							setModel(mcp);
							setView('form');
						}}
						onSave={async () => {
							await onSave(values);
							onClose();
						}}
					/>
				) : (
					<WorkspaceMcpFlowForm model={model} onPrev={() => setView('select')} onNext={onCreated} onCreate={onCreate} />
				)}
			</DialogContent>
		</Dialog>
	);
};

export { WorkspaceMcpFlow };
